import { APIRequest } from "../models/APIRequest.js";

/**
 * Page controller for collectiveapp.com/android: the Android-launch notify-list signup form.
 * On submit it posts the visitor's email and phone number to the API's /other/android endpoint
 * via APIRequest (which resolves the API origin per environment), then swaps the form for the
 * thank-you state. The server owns validation, rate-limiting, and all user-facing copy — this
 * controller authors no user-facing strings; on failure it relays the server's localized message.
 * Exported for the node --test unit suite; esbuild's IIFE bundle output drops the export.
 */
export class AndroidNotifyPage {
    constructor() {
        // Self-isolating: a throw while wiring up the form must never break the rest of the page.
        try {
            this.form = document.getElementById("android-form");
            if (!this.form) {
                return;
            }
            this.emailInput = document.getElementById("android-email");
            this.phoneInput = document.getElementById("android-phone");
            this.submitButton = document.getElementById("android-submit");
            this.signupEl = document.getElementById("android-signup");
            this.thanksEl = document.getElementById("android-thanks");
            this.errorEl = document.getElementById("android-error");

            this.form.addEventListener("submit", this._didSubmit.bind(this));
        } catch (error) {
            console.error("AndroidNotifyPage Error:", error);
        }
    }

    /**
     * Posts the signup and reveals the thank-you state on success. Re-enables the button and
     * surfaces the server's localized message on failure so the visitor can correct and retry.
     */
    async _didSubmit(event) {
        event.preventDefault();
        this.errorEl.textContent = "";

        const email = (this.emailInput.value || "").trim();
        const phone = (this.phoneInput.value || "").trim();
        if (email === "" || phone === "") {
            return; // The fields' native `required` validation prompts the visitor; nothing to post.
        }

        this.submitButton.disabled = true;
        try {
            await new APIRequest("other/android", { email, phone }).fetch();
            this._showThanks();
        } catch (error) {
            // APIRequest packs the server's localized "title\nreason" into the message; show the title.
            const message = String(error?.message || "").split("\n")[0];
            this.errorEl.textContent = message;
            alert(message);
            this.submitButton.disabled = false;
        }
    }

    /** Replaces the form with the thank-you message and the Mac download call-to-action. */
    _showThanks() {
        this.signupEl.hidden = true;
        this.thanksEl.hidden = false;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new AndroidNotifyPage();
});
